/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnalyticsRequest } from '../../models/analytics-request';
import { ApiResponseListTicketDistributionDto } from '../../models/api-response-list-ticket-distribution-dto';

export interface GetTicketDistribution$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: AnalyticsRequest
}

export function getTicketDistribution(http: HttpClient, rootUrl: string, params: GetTicketDistribution$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTicketDistributionDto>> {
  const rb = new RequestBuilder(rootUrl, getTicketDistribution.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListTicketDistributionDto>;
    })
  );
}

getTicketDistribution.PATH = '/v1/api/ui/manage-ticket/distribution-of-tickets';
